import React, { memo, useCallback, useState } from "react";
import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import BaseDialog from "./BaseDialog";
import { IEsvcsEnrollment } from "csd.phoenix.models/EsvcsEnrollment";
import { finalizeAutomatedConversion } from "../../../stores/enrollmentsStore";
import { showToast } from "../../../services/ToasterService";

interface IFinalizeActions {
  okButtonLabel?: string;
  okButtonIntent?: Intent;
  onOk: () => void;
  onCancel: () => void;
  disableButtons: boolean;
}

const FinalizeActions: React.FC<IFinalizeActions> = memo(({ okButtonLabel, okButtonIntent = Intent.SUCCESS, onOk, onCancel, disableButtons: disabledButtons }) => {
  return (
    <div className="centered">
      <Button
        text={okButtonLabel}
        intent={okButtonIntent}
        onClick={onOk}
        style={{ minWidth: 120, margin: '0 1em' }}
        disabled={disabledButtons}
      />
      <Button
        text="Cancel"
        intent={Intent.WARNING}
        onClick={onCancel}
        style={{ minWidth: 120, margin: '0 1em' }}
        disabled={disabledButtons}
      />
    </div>)
})

interface IProvisionDialogProps {
  title?: string;
  buttonLabel?: string;
  isOpen: boolean;
  enrollment: IEsvcsEnrollment;
  onClose: () => void;
  onSuccess: () => void;
}

export const FinalizeConversionDialog: React.FC<IProvisionDialogProps> = ({ title = "Finalize Automated Conversion", buttonLabel = "Yes", isOpen, onClose, onSuccess, enrollment }) => {
  const [secondConfirm, setSecondConfirm] = useState(false);
  const [disableButtons, setDisableButtons] = useState(false);
  const handleConfirm = useCallback(() => {
    if (enrollment.RecordId)
      setSecondConfirm(true);
  }, [enrollment]);

  const handleFinalize = useCallback(async () => {
    setDisableButtons(true);
    if (enrollment.RecordId) {
      const result = await finalizeAutomatedConversion(enrollment.RecordId);

      if (result) {
        showToast("Finalization request has been sent.", Intent.SUCCESS);
        onSuccess();
      } else {
        showToast("There was a problem finalizing this enrollment.  Please try again.", Intent.DANGER);
      }
      onClose();
    }
  }, [enrollment, onClose, onSuccess]);


  return (
    <>
      <BaseDialog
        title={title}
        isOpen={isOpen}
        onClose={() => onClose()}
        icon={IconNames.FlowEnd}
        canEscapeKeyClose={true}
        isCloseButtonShown={true}
        canOutsideClickClose={true}
        actions={<FinalizeActions onOk={secondConfirm ? handleFinalize : handleConfirm} onCancel={() => onClose()} okButtonLabel={buttonLabel} disableButtons={disableButtons} />}
      >
        <div style={{ textAlign: 'center' }}>
          {secondConfirm ? "Have you confirmed that this customer is fully live on Sensei Cloud and will no longer entering new data into their previous DPMS?"
            : `Would you like to finalize the automated conversion process for ${enrollment.CustomerName}?`}
        </div>
      </BaseDialog>
    </>
  )
}
